// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3PACV","addWidgetButton":"Header_addWidgetButton__3Q99C","dashboardTabs":"Header_dashboardTabs__klWHe","active":"Header_active__1gx1s"};